module.exports = __webpack_public_path__ + "img/user.1091e989.png";